import { MessageStatus } from '@govbr-ds/react-components/dist/types/messages';
import { ITributoAdicionado, ITributos } from '../../../../../../../../../../../../interfaces/ITributos';
import { removeFormatCurrency } from '../../../../../../../../../../../../utils/formatCurrency';
import { validarDeducoes } from 'utils/validarDeducoes';

export const validarReceitaBruta = (
  codigoNCMSelecionado: string,
  unidadeMedidaSelecionada: string,
  custoBruto: string,
  quantidade: number,
  tributosAdicionados: ITributoAdicionado[],
  tributosPossiveis: ITributos | undefined,
  mostrarNotificacao: (notificacao: { tipo: MessageStatus; conteudo: string }) => void,
  haCompraTerceiro: boolean,
  quantidadeTerceiro: number,
  valorTotalTerceiro: string,
  haUsoEspecifico: boolean,
  isInformacaoBaseCalculo: boolean = false
) => {
  if (!isInformacaoBaseCalculo && (!codigoNCMSelecionado || !unidadeMedidaSelecionada)) {
    mostrarNotificacao({
      tipo: 'danger',
      conteudo: 'Selecione um NCM e uma unidade de medida.',
    });
    return false;
  }
  if (!custoBruto || removeFormatCurrency(custoBruto) === 0 || !quantidade || quantidade === 0) {
    mostrarNotificacao({
      tipo: 'danger',
      conteudo: 'Digite um valor para a receita bruta de venda e para a quantidade.',
    });
    return false;
  }

  if (haCompraTerceiro && (quantidadeTerceiro === 0 || removeFormatCurrency(valorTotalTerceiro) === 0)) {
    mostrarNotificacao({
      tipo: 'danger',
      conteudo:
        'Você informou que há compra de terceiro. Por favor, informe a quantidade e o valor de aquisição de terceiros.',
    });
    return false;
  }

  if (removeFormatCurrency(custoBruto) - tributosAdicionados.reduce((acc, item) => acc + item.valor, 0) < 0) {
    mostrarNotificacao({
      tipo: 'danger',
      conteudo: 'O valor total dos tributos não pode ser maior que o valor da receita bruta.',
    });
    return false;
  }

  let errosValidacaoDeducoes = validarDeducoes(tributosAdicionados, tributosPossiveis);
  if (errosValidacaoDeducoes !== '') {
    mostrarNotificacao({
      tipo: 'danger',
      conteudo: errosValidacaoDeducoes,
    });
    return false;
  }

  if (
    haCompraTerceiro &&
    removeFormatCurrency(valorTotalTerceiro) + tributosAdicionados.reduce((acc, item) => acc + item.valor, 0) >
      removeFormatCurrency(custoBruto)
  ) {
    mostrarNotificacao({
      tipo: 'danger',
      conteudo:
        'Valor total a abater da aquisição de terceiros somado com o valor total dos tributos não pode ser maior que a receita bruta de venda.',
    });
    return false;
  }

  return true;
};
